const routes = [
	{
		path: '/',
		name: 'Dashboard',
		component: () =>
			import('@/views/reports/dashboard/ReportsDashboardView.vue'),
		meta: {
			roles: ['Settings', 'Coordinator', 'Instructor', 'Trainee'],
			permissions: [],
		},
	},
];

export default routes;
